export default {
  de: {
    thousandsSeparator: '.',
    decimalMark: ',',
  },
  en: {
    thousandsSeparator: ',',
    decimalMark: '.',
  },
  fr: {
    thousandsSeparator: '.',
    decimalMark: ',',
  },
  nl: {
    thousandsSeparator: '.',
    decimalMark: ',',
  },
  default: {
    thousandsSeparator: '',
    decimalMark: '.',
  }
};
